import React from 'react';
import _ from 'lodash';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Form, message, Input } from 'antd';

import { Title } from '@/components/Typography';
import { useOWASContext } from '../../../context';
import { useUpdateComment } from '../../../hooks/useUpdateComment';

interface CommentsProps {
	disabled?: boolean;
	onCommentChange: (editingComment: boolean) => void;
}

const { TextArea } = Input;
const { useFormInstance } = Form;

export function Comments({ onCommentChange, disabled = false }: Readonly<CommentsProps>): JSX.Element {
	const { mutateAsync } = useUpdateComment();
	const { setFieldValue } = useFormInstance();
	const { parameters, data } = useOWASContext();
	const [, contextHolder] = message.useMessage();

	const setComment = _.debounce(async (value) => {
		onCommentChange(true);
		setFieldValue('comment', value);
		await updateComment(value);
		onCommentChange(false);
	}, 1200);

	async function updateComment(text: string) {
		const payload = {
			comment: text,
			company_id: parameters?.company_id!,
			id: data?.id!,
			file_id: parameters?.file_id!,
			organization_id: parameters?.organization_id!
		};
		await mutateAsync(payload);
	}

	function handleOnChange(text: string): void {
		setComment(text);
	}

	return (
		<Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
			<Col xs={24}>
				<Title level={4} style={{ margin: 0 }}>
					{I18n.get('Comment')}
				</Title>
				{contextHolder}
			</Col>
			<Col xs={24}>
				<Form.Item name={['comment']} labelCol={{ xs: 24 }}>
					<TextArea
						rows={4}
						maxLength={500}
						showCount={true}
						disabled={disabled}
						onChange={(e) => handleOnChange(e.target.value)}
					/>
				</Form.Item>
			</Col>
		</Row>
	);
}
